import { setCurrentHelpVideo } from './vidyard.actions';
import { updateCurrentVideo } from './vidyard.repository';
import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';

const setCurrentHelpVideo$ = createEffect((actions) =>
  actions.pipe(
    ofType(setCurrentHelpVideo),
    tapResult(({ video }) => {
      updateCurrentVideo(video);
    })
  )
);

const effects = [setCurrentHelpVideo$];

export function registerVidyardEffects() {
  registerEffects(effects);
}

export function deregisterVidyardEffects() {
  removeEffects(effects);
}
